import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/approvals`;

export const approvalService = {
  submit: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  bulkApprove: async (data) => {
    const response = await axios.post(`${API_BASE}/bulk`, data);
    return response.data;
  },

  getPending: async (entityType) => {
    const response = await axios.get(`${API_BASE}/pending/${entityType}`);
    return response.data;
  },

  getHistory: async (entityType, entityId) => {
    const response = await axios.get(`${API_BASE}/${entityType}/${entityId}`);
    return response.data;
  }
};

export default approvalService;
